// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1PDAn","info":"PatientInfo_info__aZ1_J"};